import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "text-left" }
const _hoisted_2 = { style: {"background-color":"white","padding":"110px","font-size":"large"} }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "sign-up__content__formulario__img" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "sign-up__content__formulario__img__return text-left" }, [
    /*#__PURE__*/_createElementVNode("a", {
      class: "d-flex align-items-center",
      href: "/"
    }, [
      /*#__PURE__*/_createElementVNode("i", { class: "fas fa-arrow-circle-left" }),
      /*#__PURE__*/_createElementVNode("span", null, " Go back ")
    ])
  ])
], -1)
const _hoisted_4 = { class: "mb-3" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "" }, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("b", null, "GET A SUB-SYSTEM CODE")
  ])
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("hr", { class: "mt-3" }, null, -1)
const _hoisted_7 = { class: "w-100 bg-white p-4 rounded-4 mb-4" }
const _hoisted_8 = ["onSubmit"]
const _hoisted_9 = { class: "row g-3" }
const _hoisted_10 = { class: "col-md-6 mt-5" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h3", { class: "mb-3" }, "REAL ESTATE TEAM", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("option", { value: null }, "Select estate team name", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("option", null, "Realtor", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("option", null, "Broker", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("option", null, "MLO", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("option", null, "Company Title", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("option", null, "Inspector", -1)
const _hoisted_18 = [
  _hoisted_12,
  _hoisted_13,
  _hoisted_14,
  _hoisted_15,
  _hoisted_16,
  _hoisted_17
]
const _hoisted_19 = { class: "col-md-6 mt-5" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("h3", { class: "mb-3" }, "NAME", -1)
const _hoisted_21 = { class: "col-md-6 mt-5" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("h3", { class: "mb-3" }, "LAST NAME", -1)
const _hoisted_23 = { class: "col-md-6 mt-5" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("h3", { class: "mb-3" }, "COMPANY NAME", -1)
const _hoisted_25 = { class: "col-md-6 mt-5" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("h3", { class: "mb-3" }, "PHONE NUMBER", -1)
const _hoisted_27 = { class: "col-md-6 mt-5" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("h3", { class: "mb-3" }, "EMAIL", -1)
const _hoisted_29 = { class: "col-md-6 mt-5" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("h3", { class: "mb-3" }, "STATE", -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("option", { value: null }, "Select state", -1)
const _hoisted_32 = ["value"]
const _hoisted_33 = {
  key: 0,
  class: "col-md-6 mt-5"
}
const _hoisted_34 = /*#__PURE__*/_createElementVNode("h3", { class: "mb-3" }, "COUNTY", -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("option", { value: null }, "Select county", -1)
const _hoisted_36 = ["value"]
const _hoisted_37 = { class: "col-md-6 mt-5" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("h3", { class: "mb-3" }, "ZIP CODE", -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "mt-5" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "" }, " You will receive an email with a sub-system code ")
], -1)
const _hoisted_40 = { class: "reports__button d-flex justify-content-center mt-4" }
const _hoisted_41 = ["disabled"]
const _hoisted_42 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2",
  role: "status"
}

import { ref, onMounted, computed } from 'vue';
import TopBar from '@/components/admin/TopBar.vue';
import axios from 'axios';
import { environment } from "@/environment";
import { useToast } from "@/composables/useToast";
import Header from '@/components/Header.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'subsystemCodeForm',
  setup(__props) {

const toast = useToast();
const loading = ref(false);
const listStates = ref([]);
const listCounties = ref([]);
const url = environment.URL_API;

const formData = ref({
  realEstateTeam: '',
  name: '',
  lastName: '',
  companyName: '',
  phoneNumber: '',
  email: '',
  state: null,
  county: null,
  zipCode: ''
});

const isFormValid = computed(() => {
  return formData.value.realEstateTeam &&
    formData.value.name &&
    formData.value.lastName &&
    formData.value.phoneNumber &&
    formData.value.email &&
    formData.value.state &&
    formData.value.county &&
    formData.value.zipCode;
});

const resetForm = () => {
  formData.value = {
    realEstateTeam: '',
    name: '',
    lastName: '',
    companyName: '',
    phoneNumber: '',
    email: '',
    state: null,
    county: null,
    zipCode: ''
  };
  listCounties.value = [];
};


const submitRequest = async () => {
  if (!isFormValid.value) {
    toast.error("Please fill all required fields", {
      position: "top-end",
      timer: 3000,
      showCloseButton: true,
    });
    return;
  }
  loading.value = true;
  const response = await axios(`${url}realtor-format/subsystem-request`, {
    method: "POST",
    data: {
      requestData: [{
        ID: null,
        real_estate_team: formData.value.realEstateTeam,
        name: formData.value.name,
        last_name: formData.value.lastName,
        company_name: formData.value.companyName,
        phone_number: formData.value.phoneNumber,
        email: formData.value.email,
        state: formData.value.state?.state || formData.value.state,
        county: formData.value.county?.county || formData.value.county,
        zip_code: formData.value.zipCode
      }],

    }

  });

  if (!response.data.error) {
    loading.value = false;
    await toast.success(response.data.message, {
      position: "top-end",
      timer: 3000,
      showCloseButton: true,
    });
    resetForm();
  } else {
    loading.value = false;
    await toast.error(response.data.message, {
      position: "top-end",
      timer: 3000,
      showCloseButton: true,
    });
  }
};


const getStates = async () => {
  try {
    const response = await axios({
      method: "GET",
      url: `${url}realtor-format/get-states`
    });

    if (response.data.success) {
      listStates.value = response.data.states;
    } else {
      toast.error("Error loading states", {
        position: "top-end",
        timer: 3000,
        showCloseButton: true,
      });
    }
  } catch (error) {
    toast.error("Error loading states", {
      position: "top-end",
      timer: 3000,
      showCloseButton: true,
    });
    console.error("Error:", error);
  }
};

const getCountiesByState = async () => {
  if (!formData.value.state || formData.value.state === null) {
    listCounties.value = [];
    formData.value.county = null;
    return;
  }

  try {
    const response = await axios({
      method: "GET",
      url: `${url}realtor-format/get-county`,
      params: {
        state: formData.value.state.state
      }
    });

    if (response.data.success) {
      listCounties.value = response.data.county;
      formData.value.county = null;
    } else {
      toast.error("Error loading counties", {
        position: "top-end",
        timer: 3000,
        showCloseButton: true,
      });
    }
  } catch (error) {
    toast.error("Error loading counties", {
      position: "top-end",
      timer: 3000,
      showCloseButton: true,
    });
    console.error("Error:", error);
  }
};

onMounted(() => {
  getStates();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Header),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("form", {
                onSubmit: _withModifiers(submitRequest, ["prevent"])
              }, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _hoisted_11,
                    _withDirectives(_createElementVNode("select", {
                      class: "form-select form-select-sm rounded-pill border-light shadow-sm px-3 py-2",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.realEstateTeam) = $event)),
                      required: ""
                    }, _hoisted_18, 512), [
                      [_vModelSelect, formData.value.realEstateTeam]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _hoisted_20,
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control form-control-sm rounded-pill border-light shadow-sm px-3 py-2",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.name) = $event)),
                      required: "",
                      placeholder: "Enter first name"
                    }, null, 512), [
                      [_vModelText, formData.value.name]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _hoisted_22,
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control form-control-sm rounded-pill border-light shadow-sm px-3 py-2",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.lastName) = $event)),
                      required: "",
                      placeholder: "Enter last name"
                    }, null, 512), [
                      [_vModelText, formData.value.lastName]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _hoisted_24,
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control form-control-sm rounded-pill border-light shadow-sm px-3 py-2",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.companyName) = $event)),
                      placeholder: "Enter company name"
                    }, null, 512), [
                      [_vModelText, formData.value.companyName]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    _hoisted_26,
                    _withDirectives(_createElementVNode("input", {
                      type: "tel",
                      class: "form-control form-control-sm rounded-pill border-light shadow-sm px-3 py-2",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.value.phoneNumber) = $event)),
                      required: "",
                      placeholder: "Enter phone number"
                    }, null, 512), [
                      [_vModelText, formData.value.phoneNumber]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_27, [
                    _hoisted_28,
                    _withDirectives(_createElementVNode("input", {
                      type: "email",
                      class: "form-control form-control-sm rounded-pill border-light shadow-sm px-3 py-2",
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.value.email) = $event)),
                      required: "",
                      placeholder: "Enter email address"
                    }, null, 512), [
                      [_vModelText, formData.value.email]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_29, [
                    _hoisted_30,
                    _withDirectives(_createElementVNode("select", {
                      class: "form-select form-select-sm rounded-pill border-light shadow-sm px-3 py-2",
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.value.state) = $event)),
                      onChange: getCountiesByState,
                      required: ""
                    }, [
                      _hoisted_31,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(listStates.value, (state) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: state.state,
                          value: state
                        }, _toDisplayString(state.state), 9, _hoisted_32))
                      }), 128))
                    ], 544), [
                      [_vModelSelect, formData.value.state]
                    ])
                  ]),
                  (formData.value.state !== null)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                        _hoisted_34,
                        _withDirectives(_createElementVNode("select", {
                          class: "form-select form-select-sm rounded-pill border-light shadow-sm px-3 py-2",
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formData.value.county) = $event)),
                          required: ""
                        }, [
                          _hoisted_35,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(listCounties.value, (county) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: county.county,
                              value: county
                            }, _toDisplayString(county.county), 9, _hoisted_36))
                          }), 128))
                        ], 512), [
                          [_vModelSelect, formData.value.county]
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_37, [
                    _hoisted_38,
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control form-control-sm rounded-pill border-light shadow-sm px-3 py-2",
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formData.value.zipCode) = $event)),
                      required: "",
                      placeholder: "Enter zip code",
                      pattern: "[0-9]{5}(-[0-9]{4})?"
                    }, null, 512), [
                      [_vModelText, formData.value.zipCode]
                    ])
                  ])
                ]),
                _hoisted_39,
                _createElementVNode("div", _hoisted_40, [
                  _createElementVNode("button", {
                    type: "submit",
                    class: "btn btn-primary px-5 py-2 fw-bold",
                    disabled: loading.value || !isFormValid.value
                  }, [
                    (loading.value)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_42))
                      : _createCommentVNode("", true),
                    _createTextVNode(" SEND ")
                  ], 8, _hoisted_41)
                ])
              ], 40, _hoisted_8)
            ])
          ])
        ])
      ])
    ])
  ], 64))
}
}

})